<section class="news-page-wrap">
  <!-- <form class="news-form-wrap" id="newsform">
    <div class="search-input input-wrap">
      <input class="form-control rounded" placeholder="Search for specific news article"/>
      <span class="search-icon icon">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.8161 10.7955L9.09574 8.07515C9.75068 7.20326 10.1042 6.14199 10.103 5.05152C10.103 2.26613 7.83691 0 5.05152 0C2.26613 0 0 2.26613 0 5.05152C0 7.83691 2.26613 10.103 5.05152 10.103C6.14199 10.1042 7.20326 9.75068 8.07515 9.09574L10.7955 11.8161C10.9332 11.9392 11.1128 12.0049 11.2974 11.9997C11.482 11.9946 11.6577 11.9189 11.7883 11.7883C11.9189 11.6577 11.9946 11.482 11.9997 11.2974C12.0049 11.1128 11.9392 10.9332 11.8161 10.7955ZM1.44329 5.05152C1.44329 4.33788 1.65491 3.64027 2.05139 3.0469C2.44786 2.45353 3.01139 1.99105 3.67071 1.71795C4.33003 1.44485 5.05552 1.3734 5.75545 1.51262C6.45538 1.65185 7.0983 1.9955 7.60292 2.50012C8.10754 3.00474 8.45119 3.64766 8.59042 4.34759C8.72964 5.04752 8.65819 5.77301 8.38509 6.43233C8.11199 7.09165 7.64951 7.65518 7.05614 8.05165C6.46277 8.44813 5.76516 8.65975 5.05152 8.65975C4.09491 8.6586 3.17781 8.27808 2.50138 7.60166C1.82496 6.92523 1.44444 6.00813 1.44329 5.05152Z" fill="black"/>
          </svg>
      </span>
    </div>
    <div class="date-input  input-wrap">
      <input class="form-control rounded" placeholder="All Dates" type="date"/>
    </div>
  </form> -->

  <div class="news-tabs-wrapper">
    <p-tabView>
      <p-tabPanel header="General">
          <div class="general">
            <app-google-news-layout [title]="'General News'" [categoryName]="'general'" [cin]="cin" [showTittle]="true"  *ngIf="!hideGeneral"
            [showNewsImage]="false" [showExpandMore]="true" (hideLayout)="hideGeneral = true">
            </app-google-news-layout>
          </div>
      </p-tabPanel>
      <p-tabPanel header="Funding">
          <div class="funding">
            <app-google-news-layout [title]="'Funding News'" [categoryName]="'funding'" [cin]="cin" [showTittle]="true" *ngIf="!hideFunding"
            [showNewsImage]="false" [showExpandMore]="true"  (hideLayout)="hideFunding = true">
          </app-google-news-layout>
          </div>
      </p-tabPanel>
      <p-tabPanel header="Financial">
          <div class="financial">
            <app-google-news-layout [title]="'Financial News'" [categoryName]="'financial'" [cin]="cin" *ngIf="!hideFinancial"
            [showTittle]="true" [showNewsImage]="false" [showExpandMore]="true"  (hideLayout)="hideFinancial = true">
            </app-google-news-layout>
          </div>
      </p-tabPanel>
    </p-tabView>
  </div>

  <!-- <div class="container" #container>
    <div class="row">
      <div class="col-12 col-lg-9" style="scroll-behavior: smooth; scroll-margin-top: 120px" id="general"
        #general>
        <div class="wrap-generalnews mb-4">
          <app-google-news-layout [title]="'General News'" [categoryName]="'general'" [cin]="cin" [showTittle]="true"  *ngIf="!hideGeneral"
            [showNewsImage]="false" [showExpandMore]="true" (hideLayout)="hideGeneral = true">
          </app-google-news-layout>
        </div>
        <div class="wrap-fundingnews mb-4" style="scroll-behavior: smooth; scroll-margin-top: 120px" id="funding"
           #funding>
          <app-google-news-layout [title]="'Funding News'" [categoryName]="'funding'" [cin]="cin" [showTittle]="true" *ngIf="!hideFunding"
            [showNewsImage]="false" [showExpandMore]="true"  (hideLayout)="hideFunding = true">
          </app-google-news-layout>
        </div>
        <div class="wrap-financialnews mb-4" style="scroll-behavior: smooth; scroll-margin-top: 120px" id="financial"
          #financial>
          <app-google-news-layout [title]="'Financial News'" [categoryName]="'financial'" [cin]="cin" *ngIf="!hideFinancial"
            [showTittle]="true" [showNewsImage]="false" [showExpandMore]="true"  (hideLayout)="hideFinancial = true">
          </app-google-news-layout>
        </div>
      </div>
    </div>
  </div> -->
</section>

